<script lang="ts">
	import { goto, invalidate, preloadCode } from '$app/navigation';

	import * as Sidebar from '$lib/components/ui/sidebar';

	import { createNewDefaultChat } from '$lib/chats';
	import { clientRepo } from '$lib/states/client-repo.svelte';

	let busy = $state(false);
</script>

{#if clientRepo.repo}
	<Sidebar.Menu aria-label="quick access">
		<Sidebar.MenuItem class="grid px-2 my-2">
			<Sidebar.MenuButton
				variant="primary"
				onpointerenter={() => {
					preloadCode('/collections/chats/*');
				}}
				disabled={busy}
				onclick={async (evt) => {
					evt.preventDefault();

					busy = true;
					try {
						const chat = await createNewDefaultChat();
						await goto(`/collections/chats/${chat.id}#bottom`);
						invalidate('chats:recent');
					} finally {
						busy = false;
					}
				}}
			>
				<div class="flex justify-center w-full items-center gap-2">
					<span>New chat</span>
				</div>
			</Sidebar.MenuButton>
		</Sidebar.MenuItem>
	</Sidebar.Menu>
{/if}
